import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import CreateAccountForm, {
  CreateAccountFormValues,
} from "./components/CreateAccountForm";
import { publicCustomerUserClient } from "../../api";
import InviteHeading from "./components/InviteHeading";
import { useParams } from "react-router";
import { useAuth } from "../../components";
import {
  saveAccessToken,
  saveRefreshToken,
  saveRefreshTokenId,
} from "../../helpers/tokenManager";
import { useNavigate } from "../../helpers/navigationHelpers";
import { useQueryClient } from "@tanstack/react-query";
import { inviteKey } from "./queries";

type RouteParams = "invitationGuid";

const InviteCreateAccount: React.FC = (): React.ReactElement => {
  const { setUser, setOtherAccounts, setAuthenticated } = useAuth();

  const { tInvite } = useCustomTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const params = useParams<RouteParams>();

  const handleSubmit = async (values: CreateAccountFormValues) => {
    const result = await publicCustomerUserClient.register({
      email: values.email,
      password: values.password,
      invitationGuid: params.invitationGuid ?? "",
    });

    if (result.success && result.customerUser) {
      saveRefreshToken(result.refreshToken);
      saveRefreshTokenId(result.refreshTokenId);
      saveAccessToken(result.accessToken);
      setUser(result.customerUser);
      setOtherAccounts(result.contactPeople);
      setAuthenticated(true);

      await navigate.goTo("/");
      // Clear old data
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] !== inviteKey,
      });
    }
  };

  return (
    <ContentWrapper largePadding htmlTitle={tInvite("html_title")}>
      <InviteHeading />
      <div className="mt-4">
        <p className="my-3">{tInvite("create_account_description")}</p>
        <CreateAccountForm onSubmit={handleSubmit} />
      </div>
    </ContentWrapper>
  );
};

export default InviteCreateAccount;
